import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Simulacros de Examen por Materia',
  desc: 'Preguntas frecuentes de parciales y finales con respuestas desarrolladas. Farmacología, PAE, Anatomía y más.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Flashcards NANDA — Diagnósticos de Enfermería',
  desc: '50 diagnósticos NANDA listos para repasar: etiqueta, definición, factores relacionados y características definitorias.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Calculadora de Bolsillo para Enfermería',
  desc: 'Fórmulas de dosis, goteo, ml/h y cálculo por peso. Todo en una sola hoja lista para usar en clase y en sala.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Guía de Prácticas: Mi Primer Día en Sala',
  desc: 'Qué llevar, cómo presentarte, cómo comunicarte con el equipo y cómo actuar frente al paciente por primera vez.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Diccionario Pro de Abreviaturas y Siglas',
  desc: 'Más de 200 abreviaturas médicas y de enfermería explicadas. Imprescindible para entender la historia clínica.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Planificador Semestral Enfermero Cero Estrés',
  desc: 'Sistema de organización del cuatrimestre: parciales, prácticas, finales y objetivos semanales en un solo lugar.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(240,249,255) 50%, rgb(219,234,254) 100%)'
  }} data-id="element-54">
      <div className="mx-auto max-w-4xl" data-id="element-55">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-56">
          Más los <span className="text-blue-700" data-id="element-57">6 Bonos Exclusivos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-58">
          Armados para resolver los problemas reales de la carrera — incluidos siempre
        </p>

        {/* Bonus List */}
        <div className="bg-white border border-blue-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-59">
          <div className="bg-blue-700 px-5 py-2.5" data-id="element-60">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-61">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-62">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-2" data-id="element-63">
                <span className="shrink-0 text-lg font-black text-blue-700/30 w-8 text-center" data-id="element-64">
                  {bonus.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-65">
                  <span className="block text-sm font-black text-gray-900" data-id="element-66">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-67">
                    {bonus.desc}
                  </span>
                </div>
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-68">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-69">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-blue-700 rounded-full px-2 py-0.5" data-id="element-70">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-3 shadow-sm" style={{
        backgroundColor: 'rgb(240,249,255)',
        border: '1px solid rgba(59,130,246,0.3)'
      }} data-id="element-71">
          <p className="text-xs font-bold uppercase tracking-widest text-blue-700 m-0 mb-1" data-id="element-72">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-73">
            <span className="text-base text-gray-400 line-through" data-id="element-74">
              $58.000
            </span>
            <span className="text-lg font-black text-blue-700" data-id="element-75">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>
    </section>;
}